// extracted by mini-css-extract-plugin
module.exports = {"variant":"styles_variant__8_ALI","variantActive":"styles_variantActive__3eFWS","variantImg":"styles_variantImg__2EqDK","variantColor":"styles_variantColor__cHSyn"};